// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".a-errorPage__icon[data-v-2b62f953]{width:100%}.a-errorPage__title[data-v-2b62f953]{text-align:center}.a-errorPage__info[data-v-2b62f953],.a-errorPage__moreInfo[data-v-2b62f953]{text-align:center;color:#a9a9a9}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
